import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

/*
 * Theme mapped from the kairos-vas-console design tokens.
 * `primary` is the hot-pink "signal" brand so buttons, switches, and active
 * states read pink; surfaces (app bar / drawer / cards) are driven by the CSS
 * token variables in assets/css/theme.css so they stay neutral in both modes.
 */
const shared = {
  ripple: "#ff0055"
};

const stored = localStorage.getItem("cua.theme");
const prefersDark =
  window.matchMedia &&
  window.matchMedia("(prefers-color-scheme: dark)").matches;

export default new Vuetify({
  theme: {
    dark: stored ? stored === "dark" : prefersDark,
    options: { customProperties: true },
    themes: {
      light: {
        primary: "#ff0055",
        secondary: "#14181c",
        accent: "#d60048",
        error: "#e11d48",
        info: "#2f6df0",
        success: "#0f9d63",
        warning: "#cf8a09",
        ember: "#d9a406",
        background: "#f6f7f9",
        ...shared
      },
      dark: {
        primary: "#ff3d78",
        secondary: "#f6f7f9",
        accent: "#ff9bb9",
        error: "#f4415e",
        info: "#5b8bf5",
        success: "#2bb579",
        warning: "#e0a52b",
        ember: "#f0b429",
        background: "#14181c",
        ...shared
      }
    }
  },
  icons: {
    iconfont: "md"
  }
});
